import React, { createContext, useContext, useState, useCallback } from 'react';

const RolePreviewContext = createContext(null);

export const RolePreviewProvider = ({ children }) => {
  const [previewRole, setPreviewRole] = useState(null);

  const startPreview = useCallback((role) => setPreviewRole(role), []);
  const exitPreview = useCallback(() => setPreviewRole(null), []);

  // Resolves a permission against the preview role's permission list
  const previewHasPermission = useCallback(
    (permission) => {
      if (!previewRole) return null; // null = not in preview mode
      const perms = new Set(previewRole.permissions || []);
      if (perms.has('*')) return true;
      return perms.has(permission);
    },
    [previewRole]
  );

  return (
    <RolePreviewContext.Provider value={{ previewRole, startPreview, exitPreview, previewHasPermission }}>
      {children}
    </RolePreviewContext.Provider>
  );
};

export const useRolePreview = () => useContext(RolePreviewContext);
